<template>
    <div class="items">
        <div class="item" v-for="item in subItemList" :key="item.id">
            <div class="kv">
                <img :src="item.icon" />
            </div>
            <div>
                <div>
                    <div>{{item.title}}</div>
                    <div>活动时间：{{item.start_time_show}} - {{item.end_time_show}}</div>
                </div>
                <div class="btn" v-if="item.state==1" @click="go(item)">{{$route.params.type==1?'立即学习':item.state_title}}</div>
                <div class="nbtn" @click="go(item)" v-else>{{item.state_title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            subItemList: []
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        init() {
            this.$api.sports.getItemSubs({ itemid: this.$route.params.itemid }).then((res) => {
                this.subItemList = res.data.list;
            })
        },
        go(item) {
            this.$router.push({name:'newdetail',params: {id: item.id,type:this.$route.params.type}})
        }
    }
}
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>